module.exports = __webpack_public_path__ + "assets/images/project/stylised-images/party-pap.jpg?v=c4995088";